import { EventEmitter, Injectable, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ReportPayload } from '../models/report-payload';
import { ReportType } from '../models/report-types';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { MomentService } from 'src/app/vehicles/services/moment.service';
import { ReportCategory, reportTypesByCategory} from '../models/report-category';
import { reportsWithSummary } from '../configs/report-with-summary';
import Swal from 'sweetalert2';

import { ReportFormatterService } from './report-formatter.service';
import { Driver, Ibutton } from 'src/app/drivers/models/interfaces';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  public simulate = false; // solo para simular respuestas (true)

  private showImagesChecklist = new BehaviorSubject<boolean>(true);
  public currentShowImagesChecklist = this.showImagesChecklist.asObservable();

  @Output() showReport: EventEmitter<any> = new EventEmitter();
  @Output() reportFinished: EventEmitter<any> = new EventEmitter();
  @Output() reportGenerated: EventEmitter<ReportPayload> = new EventEmitter();

  constructor(
    private http: HttpClient,
    private spinner : NgxSpinnerService,
    private momentService : MomentService,
    private formatterService : ReportFormatterService
  ) { 
    this.getAllDrivers()
    this.getIbuttonAll()
  }
  private drivers: Driver[] = []
  private availableIbuttons: Ibutton[] = [];

  params : any;
  modalActive : boolean = false;
  modalReportesProgramadosActive : boolean = false;
  modalReportesProgramadosActiveDetalle : boolean = false;
  paramsReportesProgramados : any;

  listReportes : any;

  workingOnReport : boolean = false;
  objGeneral : any = {};
  chkApiGoogle : any = false;
  contReport : any = 0;
  userId : any = 0;
  chkRiesgo : any = false;

  str_nombre_eventos : any;

  eC:any; //Reporte 6 - Reporte de Eventos , Seleccion de Campo = Eventos Campos


  data = [];

  setParams(values:any) {
    console.log("se ejecuta setParams");
    this.params = values;
    //======
    this.contReport = this.contReport +1;
  }

  setShowImagesChecklist(value: boolean) {
    this.showImagesChecklist.next(value);
  }

  getParams(){
    console.log("se obtiene setParams");
    return this.params;
  }

  setApiGoogle(value:any) {
    console.log("se ejecuta setApiGoogle");
    this.chkApiGoogle = value;
  }

  setUserId(value:any) {
    console.log("se ejecuta setApiGoogle");
    this.userId = value;
  }

  getUserId(){
    console.log("se obtiene ID usuario");
    return this.userId;
  }

  setDatos(b:any){
    this.data = b;
  }

  getDatos(){
    return this.data;
  }

  // ESPECIAL EVENTS
  async getDriverListReportDriverReport(imei : string, vehicleName : string) {
    try{
      let driverResponse : any = await this.http.get(environment.apiUrl + "/api/reports/drivers_enrollments/"+imei).toPromise();
      if(driverResponse.success){
        if(!driverResponse.data[0])return;
        let list = driverResponse.data[0].cipias
        list = this.formatterService.formatDataReportDriverEnrollments(list, vehicleName)
        return list
      }
    } catch {
      return undefined
    }
  }


  // utils
  public isReportSupported(reportCode : string) : boolean {
    const support = Object.values(ReportType).includes(reportCode as ReportType);
    if(support){
      const category = this.getReportCategory(reportCode as ReportType)
      return category != ReportCategory.DEPRECATED
    }
    return false
  }

  public isReportWithSummary(reportCode: ReportType | string): boolean {
    return !!reportsWithSummary[reportCode];
  }
  public isReporBasic(reportCode: ReportType | string): boolean {
    let category = this.getReportCategory(reportCode as ReportType)
    return category == ReportCategory.BASE
  }
  public getReportCategory(reportType: ReportType): ReportCategory {
    for (const category in reportTypesByCategory) {
      if (reportTypesByCategory[category as ReportCategory].includes(reportType)) {
        return category as ReportCategory;
      }
    }
    return ReportCategory.DEPRECATED;
  }

  public reloadReport(report: ReportPayload) {
    this.spinner.show("reportSpinner");

    const dataParams = report.systemParams;

    this.http.post(environment.apiUrl + dataParams.url, dataParams).subscribe({
      next: datos => {

        this.setNameDriver(datos)

        const updatedReport: ReportPayload = {
          ...report,
          data: datos
        };

        this.reportGenerated.emit(updatedReport);
      }
    });
  }

  public saveEvaluacionEventos(report: ReportPayload, data: any[]) {
      this.spinner.show("reportSpinner");
      var arr_params = [];
      for (let index = 0; index < data.length; index++) {
        if (data[index].editado == "si") {

          const dataOrigin = this.mapReportRowToDataRow(data[index])
          arr_params.push( dataOrigin );
        }
      }
      const tzCustom = this.momentService.tzCustom;
      const tzPHP = this.momentService.tzPHP;
      const user_id = Number(localStorage.getItem('user_id'));
      var dataParams = {array_items:arr_params, user_id:user_id, tzCustom:tzCustom,tzPHP:tzPHP };

      this.http.post(environment.apiUrl + "/api/saveEventUserEvaluacion", dataParams).subscribe({
        next: (datos) => {
          // se ejecuta cuando la API devuelve datos correctamente
          this.spinner.hide("reportSpinner");
          console.log("Respuesta OK:", datos);
        },
        error: (err) => {
          // se ejecuta si ocurre un error en la petición
          this.spinner.hide("reportSpinner");
          Swal.fire({
            title: 'Error',
            text: `Ocurrió un problema al guardar la evaluación. Por favor, actualiza la página.`,
            icon: 'error',
            allowOutsideClick: false,
          });
          console.error("Error al guardar evaluación:", err);
        },
        complete: () => {
          // se ejecuta siempre al finalizar (haya éxito o error)
          console.log("Petición completada");
        }
      });

  }

  private mapReportRowToDataRow(row: any): any {
    const parametros = row.parametros || "";
    const paramEventId = parametros.match(/eventId=([^|]+)/)?.[1];
    return {
      isUnknownDriver : row.isUnknownDriver,
      new_driver_id : row.newDriverId,
      origin_driver : 'manual',
      param_event_id : paramEventId,
      fecha: row.fechaYHoraEvento || (row.fechaEvento && row.horaEvento ? `${row.fechaEvento} ${row.horaEvento}` : undefined),
      fecha_tracker: row.fechaYHoraEvento || (row.fechaEvento && row.horaEvento ? `${row.fechaEvento} ${row.horaEvento}` : undefined),
      fecha_servidor: row.fechaYHoraServidor || (row.fechaServidor && row.horaServidor ? `${row.fechaServidor} ${row.horaServidor}` : undefined),
      imei: row.trackerImei,
      tracker_imei: row.trackerImei,
      nombre_evento: row.nombreEvento,
      descripcion_evento: row.descripcion,
      codigo: row.codigo ?? "",
      placa: row.placa ?? "",
      tipo_unidad: row.tipoUnidad ?? "",
      idConductor: row.idConductor,
      conductor: row.conductor,
      fecha_evaluacion: `${row.fechaEvaluacion} ${row.horaEvaluacion}`,
      criterio_evaluacion: row.criterioEvaluacion,
      observacion_evaluacion: row.observacion ?? "",
      ComRadial: row.comunicacionRadial ?? "",
      vel_mobileye: row.velocidadMobileye ?? "",
      vel_gps: row.velocidadGps ?? "",
      vel_gps_speed: row.velocidadGPSSpeed ?? "",
      vel_can: row.velocidadCan ?? "",
      vel_eco: row.velocidadEco ?? "",
      tramo: row.nombreGeocerca ?? "",
      PC: row.puntoCercano,
      latitud: row.latitud,
      longitud: row.longitud,
      referencia: row.referencia,
      enlaceArchivo: row.enlaceArchivo,
      operador_monitoreo: row.operadorMonitoreo,
      uuid_event : row.uuid,
      // Campos adicionales sin relación con eventColumn
      slug: row.slug,
      criterion_id: row.criterioId || "",
      senales_posible_fatiga: row.senalesPosibleFatiga,
      identificacion_video: row.identificacionVideo,
      is_confirmed: row.isConfirmed,
      nombre_objeto : row.nombreObjeto,
      valoracion_evento: row.valoracionEvento,
      evento_id: row.eventoId,
      event_id: row.eventoId,
      enlaceImageCIPIA: row.enlaceImagen,
      enlaceVideoCIPIA: row.enlaceVideo,
      otro_operador_monitoreo: row.otroOperadorMonitoreo,
      es_antiguo_operador: row.esAntiguoOperador,
    };
  }

  setNameDriver(data: any) {
    for (let index of data) {
      for (let subindex of index[1]) {
        // console.log(subindex);
        if (subindex.conductor == 0) {
          subindex.conductor = '-';
        } else {
          //const nameDriver = this.driversService.getDriverById(subindex.conductor)
          const nameDriver = this.getDriverById(subindex.conductor)
          if (nameDriver == 'No Especificado') {
            subindex.conductor = '-';
          } else {
            subindex.conductor = nameDriver;
          }
        }
        if (subindex.idConductor != '-' && subindex.idConductor) { //OBTIENE LA IBUTTON COMPLETA
          //subindex.idConductor = this.driversService.getIbutton(subindex.idConductor);
          subindex.idConductor = this.getIbutton(subindex.idConductor);
          if (subindex.conductor == '-') {
            subindex.conductor = 'No Especificado';
          }
        } else {
          subindex.idConductor = '-';
        }
        // console.log('SUBINDEX IDCONDUCTOR',subindex.idConductor);
      }
    }
  }


  private getDriverById(id: number) {
    const driver = this.drivers.find(driver => driver.id == id);
    if (driver) {
      return driver.nombre_conductor;
    } else {
      return 'No Especificado';
    }
  }
  private getIbutton(idDriver: string): string {
    const ibutton = this.availableIbuttons.find((ibutton: Ibutton) =>
      ibutton.var_llave!.includes(idDriver!)
    );
    if (ibutton) {
      return ibutton.var_llave!;
    } else {
      return idDriver;
    }
  }


  private async getAllDrivers() {
    await this.http.get<any>(`${environment.apiUrl}/api/driverDataAll`).toPromise()
      .then(response => {
        console.log("------------CONDUCTORES");
        console.log(response.data);

        this.drivers = response.data[0];
        // this.ibuttons = response.data[1];
        // this.icipias = response.data[2];
        // this.idUser = response.data[3];
      });
  }

  private async getIbuttonAll() {
    await this.http.get<any>(`${environment.apiUrl}/api/ibuttonsAll`).toPromise()
      .then(response => {
        this.availableIbuttons = response.data;
      });
  }


}

